class KeepTheLoop {

    constructor() {

        this._keepTheLoopTemplate = null;
        this._pathContentCompletionPastil = null;
        this._pathAvailableTestPastil = null;
        this._keepTheLoopData = null;
        this._timeVisible = 2000;
        this._keepTheLoopVisibilityTimeOut = null;

        this._loadTemplates();

    }

    _loadTemplates() {
        this._keepTheLoopTemplate = Handlebars.compile($("#pathKeepTheLoop").html());
        this._pathContentCompletionPastil = Handlebars.compile($("#pathContentCompletionPastil").html());
        this._pathAvailableTestPastil = Handlebars.compile($("#pathAvailableTestPastil").html());
    }

    _enableHandlers() {

        $("div.show-keep-the-loop-button").on("click.indexButton", this.show.bind(this));
        $("div.next-content-button").on("click.nextContent", this.next.bind(this));
        $("div.previous-content-button").on("click.previousContent", this.previous.bind(this));

    }

    createKeepTheLoop() {

        this.deleteKeepTheLoop();

        const $keepTheLoopContainer = $("#keepTheLoopContainer");
        $keepTheLoopContainer.html(this._keepTheLoopTemplate);
        const $keepTheLoopShowButtonIcon = $("#show-keep-the-loop-button-icon");

        tintImage($keepTheLoopShowButtonIcon.attr("id"), $keepTheLoopShowButtonIcon.attr("data-icon"), "DBDBDB");

        this._enableHandlers();

    }

    deleteKeepTheLoop() {

        const $keepTheLoopContainer = $("#keepTheLoopContainer");
        $keepTheLoopContainer.children().remove();

    }

    show() {

        const $keepTheLoop = $(".keep-the-loop");

        $keepTheLoop.addClass("is-header-visible");
        this._keepTheLoopVisibilityTimeOut = setTimeout(this.hide, this._timeVisible);

    }

    hide() {

        const $keepTheLoop = $(".keep-the-loop");
        $keepTheLoop.removeClass("is-header-visible");

    }

    next() {

        function _onChangeDocumentDetails() {

            $closeDetailsButton = $("#documentation-header-close-btn");

            documentationScreenController.documentationPath.setReturnToPath(false);
            $closeDetailsButton.trigger("click");
            that.setKeepTheLoopData(document, nextDocument, previousDocument);


        }

        function _onGetItemDataSuccess(response) {

            if (api.checkisValidResult(response)) {
                if(!response.result?.document?.id) {
                    return;
                }

                document = documentationScreenController.getDocument(response.result.document.id);
                nextDocument = response.result.next;
                previousDocument = response.result.previous;

                document.isPathClassContent = true;
                document.classId = response.result.item.id;

                _onChangeDocumentDetails();

                documentationScreenController.drawDocumentDetails(null, document, null, documentationScreenController.documentation);

            }

        }

        let document = null;
        let previousDocument = null;
        let nextDocument = this._keepTheLoopData.getNextDocument();
        let testDocument = this._keepTheLoopData.getTestDocument();
        let $closeDetailsButton = $("#documentation-header-close-btn");

        if (!nextDocument && testDocument) {

            if (testDocument.isBlocked) {
                documentationScreenController.documentationPath.openBlockedContentPopUp();
            } else {
                documentationScreenController.documentationPath.setReturnToPath(true);
                documentationScreenController.documentationPath.setOpenTestOnLoad(true);
                $closeDetailsButton.trigger("click");
            }

            return;

        }

        // Último contenido de un path sin test: no hay siguiente ni test al que ir. El botón de la
        // pastilla sigue siendo clicable (su `disabled` no surte efecto en Chakra), así que se ignora el clic.
        if (!nextDocument) {
            return;
        }

        const nextDocumentId = nextDocument.id;
        const nextDocumentBlocked = nextDocument.isBlocked;
        const that = this;

        if (nextDocumentBlocked) {
            documentationScreenController.documentationPath.openBlockedContentPopUp();
        } else {
            clearTimeout(this._keepTheLoopVisibilityTimeOut);
            api.getPathItem(nextDocumentId, _onGetItemDataSuccess);
        }

    }

    previous() {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");

            documentationScreenController.documentationPath.setReturnToPath(false);
            $closeDetailsButton.trigger("click");

            that.setKeepTheLoopData(document, nextDocument, previousDocument);


        }

        function _onGetItemDataSuccess(response) {

            if (api.checkisValidResult(response)) {
                if (!response.result?.document?.id) {
                    return;
                }

                document = documentationScreenController.getDocument(response.result.document.id);
                nextDocument = response.result.next;
                previousDocument = response.result.previous;

                document.isPathClassContent = true;
                document.classId = response.result.item.id;

                _onChangeDocumentDetails();

                documentationScreenController.drawDocumentDetails(null, document, null, documentationScreenController.documentation);

            }

        }

        let document = null;
        let previousDocument = this._keepTheLoopData.getPreviousDocument();
        let nextDocument = null;

        // Primer contenido del path: no hay anterior (mismo caso que `next()` en el último).
        if (!previousDocument) {
            return;
        }

        const previousDocumentId = previousDocument.id;
        const that = this;

        clearTimeout(this._keepTheLoopVisibilityTimeOut);
        api.getPathItem(previousDocumentId, _onGetItemDataSuccess);

    }

    setKeepTheLoopData(currentDocument, nextDocument, previousDocument) {

        const $keepTheLoopIcon = $("div.keep-the-loop .content-cover");
        const $keepTheLoopCompleted = $("div.keep-the-loop .completed-content-mark");
        const $keepTheLoopSectionName = $(".keep-the-loop .content-section-and-name > p.section");
        const $keepTheLoopDocumentName = $(".keep-the-loop .content-section-and-name > p.name");
        const $keepTheLoopPrevButton = $("div.previous-content-button");
        const $keepTheLoopNextButton = $("div.next-content-button");
        const pathUtils = documentationScreenController.documentationPath.getPathUtils();
        const pathData = documentationScreenController.documentationPath.getPathData();
        const blockers = documentationScreenController.documentationPath.getBlockers();
        const lockedByRequirement = pathUtils.getBlockedByRequirement(blockers, pathData.blockers);
        const lockedByDate = pathUtils.getBlockedByDate(blockers, pathData.blockers);

        this._keepTheLoopData = new KeepTheLoopData(currentDocument, nextDocument, previousDocument, pathData);

        $keepTheLoopIcon.css("background-image", "url(" + this._keepTheLoopData.getDocumentIcon() + ")");

        $keepTheLoopSectionName.text(this._keepTheLoopData.getDocumentSectionName());
        $keepTheLoopDocumentName.text(this._keepTheLoopData.getDocumentName());

        if (this._keepTheLoopData.getDocumentIsCompleted()) {
            $keepTheLoopCompleted.show();
        } else {
            $keepTheLoopCompleted.hide();
        }

        nextDocument = this._keepTheLoopData.getNextDocument();
        const testDocument = this._keepTheLoopData.getTestDocument();


        if (nextDocument && nextDocument.isBlocked) {

            if (lockedByRequirement) {

                const $nextIcon = $keepTheLoopNextButton.find(".next-content-icon");
                const $padlockIcon = $keepTheLoopNextButton.find(".padlock-icon");

                $nextIcon.attr("class", "next-content-icon d-none");
                $padlockIcon.attr("class", "padlock-icon");

            }

            if (lockedByDate) {

                const $nextIcon = $keepTheLoopNextButton.find(".next-content-icon");
                const $calendarIcon = $keepTheLoopNextButton.find(".calendar-icon");

                $nextIcon.attr("class", "next-content-icon d-none");
                $calendarIcon.attr("class", "calendar-icon");

            }

        } else if (nextDocument && !nextDocument.isBlocked) {

            const $nextIcon = $keepTheLoopNextButton.find(".next-content-icon");
            const $padlockIcon = $keepTheLoopNextButton.find(".padlock-icon");
            const $calendarIcon = $keepTheLoopNextButton.find(".calendar-icon");

            $nextIcon.attr("class", "next-content-icon");
            $padlockIcon.attr("class", "padlock-icon d-none");
            $calendarIcon.attr("class", "calendar-icon d-none");

        } else if (!nextDocument && !currentDocument.completed && testDocument) {

            const $nextIcon = $keepTheLoopNextButton.find(".next-content-icon");
            const $padlockIcon = $keepTheLoopNextButton.find(".padlock-icon");

            $nextIcon.attr("class", "next-content-icon d-none");
            $padlockIcon.attr("class", "padlock-icon");

        }

        previousDocument ? $keepTheLoopPrevButton.show() : $keepTheLoopPrevButton.hide();

        if (nextDocument || testDocument) {
            $keepTheLoopNextButton.show();
        } else {
            $keepTheLoopNextButton.hide();
        }

        documentationScreenController.documentationPath.setReturnToPath(true);

    }

    showPointsPastil(earnedPoints) {

        function _showPastil() {
            $contentCompletedPastil.animate({top: 46}, 200);
        }

        function _scaleFlashIcon() {
            $iconsGroup.addClass("scale-flash-icon");
        }

        function _scaleFlashIconAndDisappears() {
            $iconsGroup.addClass("scale-flash-icon-and-disappears");
        }

        function _showPoints() {

            $text.hide();
            $points.show();
            $contentCompletedPastil.animate({
                width: $iconsGroup.width() + parseInt($iconsGroup.css("margin-left")) + $points.width() + parseInt($points.css("margin-left")) + 16
            }, 500);

        }

        function _unlockNextContentAnimation() {
            $text.remove()
            $points.remove();
            $iconsGroup.remove();

            // Elegir el icono apropiado para la animación de desbloqueo del siguiente contenido (flecha, candado o calendario)
            that.chooseNextContentAnimationIcon();

            that.show();
            clearTimeout(that._keepTheLoopVisibilityTimeOut);

            // Distancia desde el boton verde hasta el boton de siguiente del keep the loop
            const nextButtonWidth = 35;
            const distanceToNextButton = 40;

            //$contentCompletedPastil.animate({width: nextButtonWidth + "px"}, 100, function() {
                //$contentCompletedPastil.animate({left: distanceToNextButton + "%"}, 350, function() {
                    //setTimeout(function() {

                        that.unlockNextDocument();

                        //$contentCompletedPastil.animate({opacity: 0}, function() {

                            $keepTheLoopCompleted.show();
                            window.changeKeepTheLoopPillState();
                            $contentCompletedPastil.remove();

                            // +1 el contenido que acabamos de completar
                            if ((that._keepTheLoopData.getCompletedDocuments() + 1 === that._keepTheLoopData.getNumberOfContents()) && testDocument) {
                                that.showTestPastil();
                            } else {
                                that.hide();
                            }
                        //}

                    //});
                    //}, 2000);

            //});
            //});
        }

        function _collapsePastil(showKTL = true) {

            $text.remove()
            $points.remove();
            $iconsGroup.remove();

            //$contentCompletedPastil.animate({width: 0 + "px"}, 300, function() {
                if(showKTL) {
                    $contentCompletedPastil.remove();

                    that.show();
                    $keepTheLoopCompleted.show();
                }
            //});

        }

        const $keepTheLoop = $(".keep-the-loop");
        const $keepTheLoopContainer = $("#keepTheLoopContainer");
        const $keepTheLoopCompleted = $("div.keep-the-loop .completed-content-mark");
        const context = {
            earnedPoints: earnedPoints
        };
        const currentDocument = this._keepTheLoopData.getCurrentDocument();
        const nextDocument = this._keepTheLoopData.getNextDocument();
        const testDocument = this._keepTheLoopData.getTestDocument();
        const that = this;
        let delayTime = 0;

        $keepTheLoopContainer.append(this._pathContentCompletionPastil(context));

        const $contentCompletedPastil = $("div.content-completed-pastil");
        const $lockedContentIcon = $("div.content-completed-pastil > .padlock-icon");
        const $calendarContentIcon = $("div.content-completed-pastil > .calendar-icon");
        const $iconsGroup = $("div.content-completed-pastil > .icons-group");
        const $text = $("div.content-completed-pastil > .completed-text");
        const $points = $("div.content-completed-pastil > .points-earned");

        if (currentDocument.type !== "VIDEO" &&
            currentDocument.type !== "AUDIO" &&
            currentDocument.time_completable_total === null
        ) {
            delayTime = this._timeVisible + 300;
        }

        /*setTimeout(function() {
            _showPastil();
            setTimeout(_scaleFlashIcon, 200);
            setTimeout(_scaleFlashIconAndDisappears, 400);

            if (earnedPoints) {
                setTimeout(_showPoints, 800);
            }

            //Animation for desktop
            if ($(window).width() >= 1280) {
                setTimeout(function () {
                    $contentCompletedPastil.animate({top: "-35px"}, 200, function () {
                        if (nextDocument || testDocument) {
                            //setTimeout(function () {
                                $keepTheLoopCompleted.show();
                                window.changeKeepTheLoopPillState();
                            //}, 1500);
                        }

                        setTimeout(function () {
                            $contentCompletedPastil.animate({opacity: 0}, 300, function () {
                                $contentCompletedPastil.remove();
                            });
                        }, 1000);
                    });
                }, 1000);
            } else {
                if (nextDocument || testDocument) {
                    setTimeout(_unlockNextContentAnimation, 1000);
                } else {
                    setTimeout(_collapsePastil, 1000);
                }
            }
        }, delayTime);*/
        if (nextDocument || testDocument) {
            _unlockNextContentAnimation();
        } else {
            _collapsePastil();
        }
    }

    showTestPastil() {

        function _showPastil() {

            $availableTestPastil.animate({top: 145, opacity: 1}, 500);

            setTimeout(function() {

                $availableTestPastil.animate({top: -145, opacity: 0}, 500, function() {

                    $availableTestPastil.remove();

                    setTimeout(function() {
                        $keepTheLoop.removeClass("is-header-visible");
                    }, 1000);

                });

            }, 2000);

        }

        const $keepTheLoopContainer = $("#keepTheLoopContainer");
        const $keepTheLoop = $("div.keep-the-loop");

        $keepTheLoopContainer.append(this._pathAvailableTestPastil({}));

        const $availableTestPastil = $("div.available-test-pastil");

        _showPastil();

    }

    unlockNextDocument() {
        const $nextContentIcon = $("div.content-completed-pastil > .next-content-icon");
        const $padLockContentIcon = $("div.content-completed-pastil > .padlock-icon");
        const $calendarContentIcon = $("div.content-completed-pastil > .calendar-icon");

        const $keepTheLoopNextButton = $("div.next-content-button");
        const $nextIcon = $keepTheLoopNextButton.find(".next-content-icon");
        const $padlockIcon = $keepTheLoopNextButton.find(".padlock-icon");
        const $calendarIcon = $keepTheLoopNextButton.find(".calendar-icon");

        const nextDocument = this._keepTheLoopData.getNextDocument();
        const testDocument = this._keepTheLoopData.getTestDocument();

        // Mirar cual es el icono que se ha puesto en la animación tras completarlo y poner el mismo en el boton de continuar en el keep the loop.
        if ($nextContentIcon.attr("class").indexOf("d-none") < 0) {

            if (nextDocument) {
                this._keepTheLoopData.setNextDocumentBlocked(false);
            } else if (testDocument) {
                this._keepTheLoopData.setTestBlocked(false);
            }

            $calendarIcon.attr("class", "calendar-icon d-none");
            $padlockIcon.attr("class", "padlock-icon d-none");
            $nextIcon.attr("class", "next-content-icon");
            return;
        }

        if ($padLockContentIcon.attr("class").indexOf("d-none") < 0) {
            $padlockIcon.attr("class", "padlock-icon");
            return;
        }

        if ($calendarContentIcon.attr("class").indexOf("d-none") < 0) {
            $calendarIcon.attr("class", "calendar-icon");
            return;
        }
    }

    chooseNextContentAnimationIcon() {
        const $nextContentIcon = $("div.content-completed-pastil > .next-content-icon");
        const $padLockContentIcon = $("div.content-completed-pastil > .padlock-icon");
        const $calendarContentIcon = $("div.content-completed-pastil > .calendar-icon");

        const pathData = documentationScreenController.documentationPath.getPathData();
        const pathUtils = documentationScreenController.documentationPath.getPathUtils();
        const blockers = documentationScreenController.documentationPath.getBlockers();
        const nextDocument = this._keepTheLoopData.getNextDocument();
        const currentDocument = this._keepTheLoopData.getCurrentDocument();
        const testDocument = this._keepTheLoopData.getTestDocument();

        if ((nextDocument && pathData.blockers.length === 0) || (!nextDocument && testDocument)) {
            $nextContentIcon.attr("class", "next-content-icon");
            return;
        }

        if (pathUtils.getBlockedByDate(blockers, pathData.blockers)) {
            if (nextDocument.isBlocked) {
                $calendarContentIcon.attr("class", "calendar-icon");
            } else {
                $nextContentIcon.attr("class", "next-content-icon");
            }

            return;
        }

        if (pathUtils.getBlockedByRequirement(blockers, pathData.blockers)) {
            if (pathData?.blocker?.type === blockers.BLOCKER_SEQUENTIAL_BY_CONTENT) {

                $nextContentIcon.attr("class", "next-content-icon");
            } else {
                const section = this._keepTheLoopData.getDocumentSection();
                const sectionItems = section.items;
                const lastItemSection = section.items[section.items.length - 1];

                if (currentDocument.id === lastItemSection.id) {

                    // El contenido actual acaba de completarse: puede que el ítem aún no lo refleje.
                    if (_.every(sectionItems, item => item.completed || item.id === currentDocument.id)) {
                        $nextContentIcon.attr("class", "next-content-icon");
                    } else {
                        $padLockContentIcon.attr("class", "padlock-icon");
                    }

                } else {
                    $nextContentIcon.attr("class", "next-content-icon");
                }
            }
        }

    }

}